import { Pipe, PipeTransform } from '@angular/core';

import { Question } from '../models/question.model';

@Pipe({
  name: 'qTitle',
  pure: true
})
export class QuestionTitlePipe implements PipeTransform {
  transform(qId: string, questions: Question[]): string {
    return questions.find((q) => q.id === qId)?.title;
  }
}
